"use client";
import type { StorefrontProductMedia } from "./types";

export function ProductImage({ media, src, alt, sizes = "(min-width: 1200px) 360px, (min-width: 700px) 33vw, 100vw", priority = false }: {
  media?: StorefrontProductMedia; src?: string; alt: string; sizes?: string; priority?: boolean;
}) {
  return <picture>
    {media?.srcsetAvif ? <source type="image/avif" srcSet={media.srcsetAvif} sizes={sizes} /> : null}
    {media?.srcsetWebp ? <source type="image/webp" srcSet={media.srcsetWebp} sizes={sizes} /> : null}
    <img src={media?.src ?? src} alt={alt} width={media?.width} height={media?.height}
      loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : undefined} decoding="async" />
  </picture>;
}
